<template>
    <div>
        <AssemblyLayout            
            viewComponent="AssemblyCreate"
            :cardInfo="this.cardInfo"
            :leftAction="this.leftAction"
        />
    </div>
</template>
<script>
import Vue from "vue";
import AssemblyLayout from "../components/AssemblyLayout.vue";
import RoutesPaths from "../../../router/router-structure/routes-paths";

Vue.component("AssemblyCreate", () =>
  import("../components/forms/AssemblyCreate.vue")
);

export default {
  components: {
    AssemblyLayout,
  },
  data: function() {
    return {
      leftAction: {
        text: "Cadastrar Assembleia",
        onClick: this.leftActionClickHandler,
      },
      cardInfo: {
        icon: "MDI-calendar-check.svg",
        title: "Participação Assembleia",
        description: "Registre a participação dos cooperados nas assembleias e reuniões",
      },
    };
  },
  methods: {
    leftActionClickHandler() {
      this.$router.push({
        path: RoutesPaths.contentManagement.assemblyManagement(),
        replace: true,
      });
    },
  },
    
}
</script>